<template lang="pug">
	.creative-version-create-storyboard(v-if="showed" v-window)
		.card(@click.stop="unselect()")
			.card-header
				span Create new storyboard
			.card-body.collapse.show
				.storyboards(:span="8")
					.storyboard-container(v-for="template in Metadata.Templates" v-if="template.type === 'storyboard' && template.active === 1 && (!template['publisher_id'] || template['publisher_id'] === Publisher.SelectedPublisher['id'])" :class="{selected: template === selectedTemplate}" @click.stop="select(template)")
						.preview(:style="{backgroundImage: `url(/Images/Icons/Storyboards/${template.codename}.png)`}")
						span.title {{template.title}}
						span.description.text-muted(v-if="template.description") {{template.description}}
			.card-body.collapse.show(@click.stop)
				.form-horizontal
					.progress.upload-progress(:style="{visibility: uploadingPsd ? 'visible' : 'hidden'}")
						.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuemin="0" aria-valuemax="100" :style="{width: (uploadProgress * 100) + '%'}")
					.upload-error.text-danger(v-if="uploadError") {{uploadError}}
					.form-actions
						button.btn.btn-primary(v-if="selectedTemplate" type="submit" :class="{disabled: !selectedTemplate}" v-on:click="createFromTemplate()")
							i.fa.fa-plus
							| &nbsp;&nbsp;Create from template
						button.btn.btn-primary(v-if="!selectedTemplate" type="submit" v-on:click="createFromScratch()")
							i.fa.fa-plus
							| &nbsp;&nbsp;Create from scratch
						//button.btn.btn-primary.disabled(v-if="!selectedTemplate" type="button" disabled)
							i.fa.fa-plus
							| &nbsp;&nbsp;Create from Screenshots
						button.btn.btn-warning(type="submit" v-if="Access.check('storyboard-templates-edit') && selectedTemplate" v-on:click="openTemplateSettings()")
							i.fa.fa-cog
							| &nbsp;&nbsp;Template settings
						button.btn.btn-warning(type="button" v-if="Access.check('storyboard-templates-edit') && !selectedTemplate" :disabled="uploadingPsd" :class="{disabled: uploadingPsd}" v-on:click="openFileDialog()")
							i.fa.fa-spinner.fa-spin(v-if="uploadingPsd")
							i.fa.fa-plus(v-else)
							| &nbsp;&nbsp;Add template by psd/json
						//button.btn.btn-danger.delete-template(type="button" v-if="Access.check('storyboard-templates-edit') && selectedTemplate && selectedTemplate.options.custom" v-on:click="deleteTemplate()")
							i.fa.fa-remove
							| &nbsp;&nbsp;Delete template
						button.btn.btn-dark(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'
	import { Auth } from "../../services/Auth";

	import { Creative } 			from "@/services/Creative";
	import { Asset } 			from "@/services/Asset";
	import SetupSettings 		from "./../../settings/settings";

	export default {
		name: "StoryboardCreateVersion",
		mixins: [Screen],
		screen: {
			updateOn: ["Metadata Loaded"],
			events: {
				"Show StoryboardCreateVersion": function() {

					this.selectedTemplate = null;
					this.stopUploadingPsd();

				},
				"StoryboardCreateVersion Hided": function() {

					this.stopUploadingPsd();

				},
				"Metadata Loaded": function() {

					this.selectedTemplate = null;
					this.stopUploadingPsd();

				},
				// Загружен json файл шаблона - дальше работает компонент TemplateCreate
				"Server Data:TemporaryTemplate": function() {

					this.stopUploadingPsd();

				},
				"Server Data:TemporaryTemplateError": function(errorMessage) {

					this.stopUploadingPsd();

					if (this.showed) this.uploadError = errorMessage;

				}
			}
		},
		data() {

			return {
				showed: false,
				selectedTemplate: null,
				uploadingPsd: false,
				uploadProgress: 0,
				uploadError: ''
			};

		},
		beforeDestroy() {

			this.stopUploadingPsd();

		},
		methods: {
			collectData() {

			},
			stopUploadingPsd() {

				this.uploadingPsd = false;
				this.uploadProgress = 0;

				if (this.uploadTimeout) {

					clearTimeout(this.uploadTimeout);
					this.uploadTimeout = null;

				}

			},
			select(template) {

				this.selectedTemplate = template;

			},
			unselect() {

				this.selectedTemplate = null;

			},
			createFromTemplate() {

				if (!this.selectedTemplate) return;

				Server.sendToSocket({
					CreateStoryboardFromTemplate: {
						creativeId: Creative.SelectedCreative.id,
						templateCodename: this.selectedTemplate.codename
					}
				});

				this.hide();

			},
			createFromScratch() {

				Server.sendToSocket({
					CreateStoryboardFromScratch: {
						creativeId: Creative.SelectedCreative.id
					}
				});

				this.hide();

			},
			openTemplateSettings() {

				Broadcast.call("Show TemplateSettings", [null, this.selectedTemplate.id, 'storyboard']);

			},
			deleteTemplate() {

				Broadcast.call('Show Confirm', [{
					caption: 'Delete storyboard template',
					message: `Are you sure you want to delete storyboard template "${this.selectedTemplate.title}"?`,
					confirmButtonText: '&nbsp;&nbsp;Delete template',
					confirmButtonIcon: 'fa-remove',
					confirmCallback: () => {

						Server.sendToSocket({
							DeleteTemplate: {
								templateCodename: this.selectedTemplate.codename
							}
						});

					}
				}]);

			},
			openFileDialog() {

				if (this.uploadingPsd) return;

				Asset.requestFile(".psd,.psb,.json", file => {

					if (file) this.uploadPsdFile(file);

				});

			},
			// psd/psb файл - шаблон создаётся сразу, json файл - открывается окно TemplateCreate для загрузки psd файлов размеров
			uploadPsdFile(file) {

				this.uploadingPsd = true;
				this.uploadProgress = 0;
				this.uploadError = '';

				if (this.uploadTimeout) clearTimeout(this.uploadTimeout);

				// На случай, если ответ от сервера так и не придёт - не оставляем кнопку заблокированной навсегда
				this.uploadTimeout = setTimeout(() => {

					this.stopUploadingPsd();

				}, 30000);

				let formData = new FormData();

				formData.append("file", file);
				formData.append("templateType", "storyboard");

				let url = `${location.protocol}//${SetupSettings["domain"]}/template/addTemplateByPsd`;

				let xhr = new XMLHttpRequest();


				xhr.upload.addEventListener("progress", e => {

					if (e.lengthComputable) this.uploadProgress = e.loaded / e.total;

				});

				// Результат придёт через сокет: Metadata (шаблон из psd) или Server Data:TemporaryTemplate (json)
				xhr.open("POST", url);
				Auth.authorizeRequest(xhr);

				xhr.send(formData);

			}
		}
	}
</script>

<style lang="sass">

	.creative-version-create-storyboard
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.card
			width: 850px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 500px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: transform 0.2s

			.storyboards
				display: flex
				flex-wrap: wrap
				justify-content: space-around
				align-items: center
				max-height: 360px
				overflow-y: auto

				.storyboard-container
					display: flex
					flex-direction: column
					align-items: center
					width: 250px
					margin: 10px
					cursor: pointer
					text-align: center
					border: 1px solid #4c4f54
					border-radius: 5px
					box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .14), 0 2px 1px -1px rgba(0, 0, 0, .12), 0 1px 3px 0 rgba(0, 0, 0, .20)
					background-color: #343b41
					overflow: hidden

					&.selected
						border-color: #e1a82d

					.preview
						display: block
						width: 248px
						height: 140px
						margin: 10px
						margin-top: 0
						background-size: contain
						background-repeat: no-repeat
						background-position: center

					.title
						margin-bottom: 10px

					.description
						font-size: 12px
						line-height: 14px
						padding: 0 10px
						margin-top: -6px
						margin-bottom: 10px

			.upload-error
				position: absolute
				left: 20px
				bottom: 60px

			.progress.upload-progress
				position: absolute
				left: 20px
				right: 20px
				bottom: 80px
				height: 5px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

				button.btn-primary, button.btn-warning
					margin-right: 20px

			.two-setting-panel
				display: flex
				flex-direction: row
				justify-content: space-between

			.col-form-label
				display: flex
				flex-direction: row
				line-height: 32px
				justify-content: space-between

				.title
					display: flex
					overflow: hidden
					text-overflow: ellipsis
					white-space: nowrap
					flex-direction: row
					align-items: baseline

					.icon-info
						color: #20a8d8

	.creative-version-create-storyboard.hiding
		opacity: 0

		.card
			transform: scale(0.9)

</style>
